import React, { Component, ReactNode } from 'react';

import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import { connect } from 'react-redux';
import CumulativeWeeklyDataChart from '../../../../components/Charts/CumulativeWeeklyDataChart';
import chartsGuide from '../../../../utils/charts/charts_guide.json';

// https://apexcharts.com/react-chart-demos/line-charts/brush-chart/
// https://apexcharts.com/react-chart-demos/area-charts/github-style/

// TODO : Missing bar for cumulative

interface Props {
    loading: boolean
    data?: any

    // redux
    layout: any
}
interface State {
    data_chart: React.ReactNode
}

// export default
class WeeklyStatistics extends Component<Props, State>{

    constructor(props:Props){
        super(props);
    }

    render() {
        // console.debug("layout",this.props.layout);
        return (
            <div className="weekly-statistics">
                <div className="date-charts">
                    {
                        this.props.loading ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.props.data ?
                                <>
                                    <CumulativeWeeklyDataChart
                                        title="Weekly MEAN throughput"
                                        data={this.props.data.stat[0]}
                                        size width={this.props.layout.width < 1000 ? this.props.layout.width - 20 : 1000}
                                        data_rate
                                        throughput
                                        chartData={chartsGuide.bar_chart}
                                    />
                                </> 
                                :
                                <div className="no-data">No data</div>
                    }
                </div>
            </div>
        );
    }

};
export default connect((state:any)=>{
    return {
        layout: state.layout
    }
})(WeeklyStatistics)